import _ from 'lodash';

import createModel, { prop } from '../lib/create_model';
import InteractionType from 'models/interaction_type';
import NotificationType from './notification_type';
import { SessionCustomer } from '../active_session';

export default createModel({
  modelName: 'IncomingConcurrentSessionNotification',

  properties: {
    id: prop(String),
    profile: prop(SessionCustomer),
    sessionType: prop().oneOf(..._.keys(InteractionType)),
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.INCOMING_CONCURRENT_SESSION });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/notification/incoming_concurrent_session_notification.js